import type { ReactNode } from 'react';

const ROW =
  'flex flex-wrap items-stretch gap-2 [&>button]:max-w-full [&>span]:max-w-full max-sm:[&>button]:flex-1 max-sm:[&>span]:flex-1 max-sm:[&>button]:basis-[8rem] max-sm:[&>span]:basis-[8rem]';

export function HelperActionRows({
  primary,
  secondary,
  quiet,
  testId,
}: {
  primary: ReactNode;
  secondary?: ReactNode;
  quiet?: ReactNode;
  testId?: string;
}): ReactNode {
  return (
    <div className="space-y-2" data-testid={testId}>
      <div className={ROW} data-testid={testId ? `${testId}-top` : undefined}>
        {primary}
        {secondary}
      </div>
      {quiet && (
        <div className={ROW} data-testid={testId ? `${testId}-quiet` : undefined}>
          {quiet}
        </div>
      )}
    </div>
  );
}
